"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberMatch = exports.clamp = exports.getWindowSize = void 0;
var getWindowSize = function () { return ({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0
}); };
exports.getWindowSize = getWindowSize;
var clamp = function (min, max, value) {
    return Math.max(min, Math.min(max, value));
};
exports.clamp = clamp;
var getNumberMatch = function (prop, type) {
    var windowSize = (0, exports.getWindowSize)();
    if (prop === '100%') {
        return windowSize[type];
    }
    if (prop) {
        var match = prop.toString().match(/(\d+)/);
        if (match) {
            var amount = parseInt(match[0], 10);
            if (prop.includes('vh') || prop.includes('vw')) {
                return (windowSize[type] * amount) / 100;
            }
            return amount;
        }
    }
    return undefined;
};
exports.getNumberMatch = getNumberMatch;
